var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZanzariereZanzara(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    id: "svg16",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs16"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinejoin: "bevel",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 34.615661,26.376349 c -0.07318,0.306355 -0.135464,1.736562 -0.183755,2.048184 -0.01554,0.08569 -0.02759,0.151307 -0.04102,0.228516 l -0.08594,0.488281 -0.111328,0.01367 c -0.20716,0.02778 -0.362406,0.176053 -0.433594,0.392578 -0.0013,0.0033 -0.0026,0.0065 -0.0039,0.0098 -0.0014,0.0046 -0.0025,0.009 -0.0039,0.01367 -0.02568,0.07071 -0.03664,0.154082 -0.03516,0.238282 -1.04e-4,0.007 3.7e-5,0.01451 0,0.02148 -9.33e-4,0.175908 0.02002,0.335128 0.152344,0.425781 0.0056,0.0055 0.01177,0.0089 0.01758,0.01367 0.02514,0.02087 0.04099,0.03826 0.04297,0.05273 v 0.002 0.002 0.002 l -0.002,0.002 v 0.002 c -0.0083,0.02243 -0.05261,0.04303 -0.140625,0.07227 -0.185389,0.06158 -0.433988,0.146091 -0.480468,0.347656 l -0.22461,0.976563 0.01367,0.197265 -0.210938,0.06836 c -0.116176,0.03674 -0.31135,0.102134 -0.433593,0.146484 -0.219043,0.07947 -0.813643,0.263848 -1.480469,0.457031 -0.187437,0.0543 -0.488684,0.142333 -0.667969,0.195313 -0.179289,0.05299 -0.419112,0.118804 -0.533203,0.146484 -0.203183,0.0493 -0.392152,0.103784 -1.259766,0.373047 -0.75309,0.233722 -1.22237,0.451673 -1.410156,0.654297 -0.05791,0.06248 -0.07031,0.109015 -0.07031,0.244141 0,0.143898 0.01176,0.183743 0.09375,0.283203 0.118713,0.144019 0.536842,0.347195 0.853515,0.416015 0.668829,0.145337 0.870425,0.169628 1.482422,0.173828 0.334125,0.0024 0.664618,-0.0096 0.736328,-0.01953 1.248068,-0.195386 2.325365,-0.793204 3.109375,-1.820312 l 0.16211,-0.214844 0.117187,0.181641 c -0.251789,0.563323 -0.418974,1.235136 -0.291015,1.996093 -0.195984,0.75102 -0.196011,1.399828 0.002,2.248047 0.272475,1.167251 0.631327,1.986641 1,2.289063 0.170375,0.139758 0.297013,0.182999 0.441406,0.126953 0.02058,-0.008 0.04104,-0.01929 0.0625,-0.03125 0.04292,-0.02393 0.08816,-0.05587 0.136719,-0.0957 0.368673,-0.302422 0.727525,-1.121812 1,-2.289063 0.09898,-0.424109 0.147985,-0.797973 0.148437,-1.160156 4.53e-4,-0.362183 -0.04847,-0.712381 -0.146484,-1.087891 0.127959,-0.760957 -0.03923,-1.43277 -0.291016,-1.996093 l 0.117188,-0.181641 0.162109,0.214844 c 0.78401,1.027108 1.861307,1.624926 3.109375,1.820312 0.07171,0.0099 0.402203,0.02194 0.736328,0.01953 0.611997,-0.0042 0.813593,-0.02849 1.482422,-0.173828 0.316673,-0.06882 0.734803,-0.271996 0.853516,-0.416015 0.08199,-0.09946 0.09375,-0.139305 0.09375,-0.283203 0,-0.135126 -0.0124,-0.18166 -0.07031,-0.244141 -0.187637,-0.20305 -0.656916,-0.421001 -1.410007,-0.654723 -0.867614,-0.269263 -1.056583,-0.323749 -1.259766,-0.373047 -0.114091,-0.02768 -0.353914,-0.0935 -0.533203,-0.146484 -0.179285,-0.05298 -0.480531,-0.141012 -0.667969,-0.195313 -0.666826,-0.193183 -1.261425,-0.377557 -1.480468,-0.457031 -0.122243,-0.04435 -0.317418,-0.109744 -0.433594,-0.146484 l -0.210938,-0.06836 0.01367,-0.197265 -0.224609,-0.976563 c -0.04648,-0.201565 -0.29508,-0.28608 -0.480469,-0.347656 -0.08801,-0.02923 -0.13234,-0.04984 -0.140625,-0.07227 v -0.002 l -0.002,-0.002 v -0.002 -0.002 l 0.002,-0.002 c 0.002,-0.01447 0.01587,-0.03187 0.04102,-0.05273 0.0058,-0.0048 0.01203,-0.0082 0.01758,-0.01367 0.132325,-0.09065 0.153277,-0.249873 0.152344,-0.425781 -3.7e-5,-0.007 1.04e-4,-0.01446 0,-0.02148 0.0015,-0.0842 -0.0095,-0.167569 -0.03516,-0.238282 -0.0024,-0.0081 -0.0052,-0.01548 -0.0078,-0.02344 -0.07119,-0.216525 -0.226434,-0.364797 -0.433594,-0.392578 l -0.111328,-0.01367 -0.08594,-0.488281 -0.04102,-0.228516 c -1.51e-4,-8.54e-4 1.51e-4,-0.0011 0,-0.002 -0.03619,-0.300669 -0.125222,-1.796769 -0.183596,-2.045791 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 28.853784,27.544287 c 1.825254,0.561373 2.695486,1.202188 3.143744,1.538287 0.448259,0.3361 -0.661629,1.043978 -0.479869,1.552104 0.18176,0.508126 1.519481,0.530639 1.519481,0.530639",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 33.124757,34.550636 c -0.364387,0.229326 -0.742947,0.430958 -1.1397,0.844768 -0.585297,0.610459 -0.367521,2.925875 -0.611979,3.547929 -0.244458,0.622054 -1.402431,2.196781 -2.269745,3.400743",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 30.612598,35.149027 c -0.03385,0.593704 -0.1332,1.652882 -0.416999,1.966115 -0.406294,0.448433 -2.873977,2.316224 -2.873977,2.316224",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 40.420345,27.544287 c -1.825254,0.561373 -2.695486,1.202188 -3.143744,1.538287 -0.448259,0.3361 0.661629,1.043978 0.479869,1.552104 -0.18176,0.508126 -1.519481,0.530639 -1.519481,0.530639",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 36.149372,34.550636 c 0.364387,0.229326 0.742947,0.430958 1.1397,0.844768 0.585297,0.610459 0.367521,2.925875 0.611979,3.547929 0.244458,0.622054 1.402431,2.196781 2.269745,3.400743",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 38.661531,35.149027 c 0.03385,0.593704 0.1332,1.652882 0.416999,1.966115 0.406294,0.448433 2.873977,2.316224 2.873977,2.316224",
    id: "path9"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path11",
    cx: 34.69886,
    cy: 34.635387,
    r: 12.538318
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.0907927,29.100392 21.257266,42.266866",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.1262697,23.393458 22.268135,37.535323",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.306387,17.831161 22.12698,31.651754",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 7.7801628,34.532175 8.0786342,8.078634",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 7.7254806,40.219908 2.3159054,2.315905",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 11.286638,9.3265885 26.451867,24.491817",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 14.418869,6.1943578 30.479583,22.255072",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 19.88208,6.1940529 35.450959,21.762931",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 25.367486,6.215946 42.279874,23.128333",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 30.877472,6.2624192 41.743785,17.128729",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 36.165893,6.1600925 5.602609,5.6026055",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.4106031,12.192967 23.574814,27.357177",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 21.470536,42.480135 1.999531,-1.999529",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 37.353145,21.802037 4.561641,-4.517819",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 31.225263,22.321361 41.734775,11.811849",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.1086458,34.217339 36.165893,6.1600925",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.1043662,28.793426 30.753477,6.1443175",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.2960915,23.173514 25.228975,6.2406323",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.3151802,17.726238 19.783231,6.2581872",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.4154308,12.197795 14.418137,6.1950899",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.2796479,39.658419 38.978427,8.9596398",
    id: "path37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g53",
    transform: "translate(30.678569,-109.87237)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 13.625316,0.7455903 V 42.263991",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 16.897328,0.7455903 V 42.263991",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 20.169341,0.7455903 V 42.263991",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 10.353303,0.7455899 V 42.263991",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8092779,0.7455899 V 42.263991",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 7.0812904,0.7455899 V 42.263991",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 26.713366,0.7455906 V 42.263991",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 29.985378,0.7455906 V 42.263991",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 33.257391,0.7455906 V 42.263991",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 36.529403,0.7455906 V 42.263991",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 39.801416,0.7455906 V 42.263991",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.03581,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 43.069958,0.90092826 V 42.267461",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.04275,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 23.441353,0.7455906 V 42.263991",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.03581,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 46.335031,0.90092872 V 42.267461",
    id: "path53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g67",
    transform: "translate(31.174126,-110.17197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.0488,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8154862,32.867727 H 45.817054",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.0488,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8154862,29.671985 H 45.817054",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.0488,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8154862,26.476242 H 45.817054",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.09364,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8379062,36.085889 H 45.839474",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.09364,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8379062,42.567054 H 45.839474",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.09364,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8379062,39.326472 H 45.839474",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.0488,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8154862,20.084758 H 45.817053",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.0488,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8154862,16.889015 H 45.817053",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.0488,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8154862,13.693273 H 45.817053",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.0488,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8154862,10.497531 H 45.817053",
    id: "path63"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.0488,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8154862,7.3017884 H 45.817053",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.05501,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8185912,4.102941 H 46.31888",
    id: "path65"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.0488,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8154862,23.2805 H 45.817053",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#00ffff",
      strokeWidth: 1.05513,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.8186512,0.90092872 H 46.328683",
    id: "path67"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 16.020732,42.772744 5.879891,-5.879892",
    id: "path101"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 10.570926,43.065353 22.445692,31.190586",
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 41.715462,23.710895 0.564412,-0.582562",
    id: "path1"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZanzariereZanzara);
export default __webpack_public_path__ + "static/media/zanzariere_zanzara.471a2af439b5cc8c232b70ab48aff919.svg";
export { ForwardRef as ReactComponent };